export default {
  "templates.popoverProfile.myAccount": {
    en: "My account",
    es: "Mi cuenta",
  },
  "templates.popoverProfile.logout": {
    en: "Logout",
    es: "Cerrar sesión",
  },
  "templates.router.app.trialText.expires": {
    en: "The trial version of Quoters ends <strong>__$1__</strong>!",
    es: "¡La versión trial de Quoters finaliza <strong>__$1__</strong>!",
  },
  "templates.router.app.trialText.expired": {
    en: "The trial version of Quoters ended <strong>__$1__</strong>!",
    es: "¡La versión trial de Quoters ha finalizado <strong>__$1__</strong>!",
  },
  "templates.router.app.trialText.subscribe": {
    en: 'Get subscribed to continue enjoying Quoters by clicking <a href="__$1__">here</a>',
    es: 'Suscríbete para poder seguir disfrutando de Quoters haciendo click <a href="__$1__">aquí</a>.',
  },
  "templates.router.notFound.title": {
    en: "Oops",
    es: "Ups",
  },
  "templates.router.notFound.text": {
    en: "This page could be not found",
    es: "Esta página no existe",
  },
  "templates.typeahead.pricingTableTariffs.containsCosts": {
    en: "This rate has related costs",
    es: "Esta tarifa tiene costes asociados",
  },
};
